import React from "react";
import { Link } from "react-router-dom";

/* PICTURES & ICONS */
import ICON_GEOMETRY from "../../Assets/jsx/ICON_GEOMETRY";
import icon_edit_point from "../../Assets/svg/icon_edit_point.svg";
import icon_edit_line from "../../Assets/svg/icon_edit_line.svg";
import icon_edit_polygon from "../../Assets/svg/icon_edit_polygon.svg";
import icon_delete_geometry from "../../Assets/svg/icon_delete_geometry.svg";

/* DATA */
import domain_list from "../../Data/domain_list";
import useLanguage from "../common_hooks/useLanguage";

const MAP_TOP_BAR = ({
  auth,
  is_mobile,
  geometryStatus,
  draw_active,
  current_type,
  on_activate_input_status,
  on_stop_geometry,
  on_create_geometry,
  on_delete_geometry,
  on_stop_draw,
  toggle_share_modal,
  post_activities,
}) => {
  const { domain } = auth;
  const { dict, language } = useLanguage();

  return (
    <section className="map_top_bar">
      <Link
        id="home_ui"
        to={"/dashboard"}
        style={{
          paddingLeft: "5px",
          display: "flex",
          alignItems: "center",
          textDecoration: "none",
        }}
      >
        <img
          src={
            is_mobile
              ? domain_list?.[domain]?.mobile_logo
              : domain_list?.[domain]?.logo_black
          }
          height="30px"
          alt="Back"
          data-mapid="clickHome"
        />
      </Link>

      <div
        style={{
          position: "absolute",
          left: "50%",
          transform: "translateX(-50%)",
          display: "flex",
          alignItems: "center",
          gap: "10px",
        }}
      >
        <button
          onClick={on_activate_input_status}
          id="search_ui"
          className="badge button_white outline_grey"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="11" cy="11" r="8"></circle>
            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
          </svg>
          {!is_mobile
            ? dict["Search Data or Location"][language]
            : dict["Search"][language]}
        </button>

        <>
          <div
            id="vertical_line"
            style={{
              width: "2px",
              height: "24px",
              backgroundColor: "#e0e0e0",
            }}
          ></div>
          <div
            id="draw_ui"
            className={`outline_grey ${geometryStatus ? "green_container" : ""}`}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "29px",
              height: "29px",
              borderRadius: "8px",
              color: "#555",
              cursor: "pointer",
              padding: 0,
            }}
            onClick={on_stop_geometry}
          >
            <ICON_GEOMETRY
              color={geometryStatus ? "#000" : "#b7b7b7"}
              strokeWidth={geometryStatus ? 4 : 3}
              style={{ width: "20px", height: "20px" }}
            />
          </div>

          {geometryStatus && (
            <>
              <button
                id="edit_icon"
                onClick={() => {
                  on_create_geometry();
                  post_activities({
                    action: "start_drawing",
                  });
                }}
                data-mapid="clickDigitasi"
                className={`outline_grey ${draw_active ? "green_container" : ""}`}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "32px",
                  height: "32px",
                  borderRadius: "8px",
                  color: "#555",
                  cursor: "pointer",
                  padding: 0,
                }}
                title={draw_active ? "End drawing" : "Start drawing"}
              >
                {current_type === "Point" ? (
                  <img alt="Point" src={icon_edit_point} height={15} />
                ) : current_type === "LineString" ? (
                  <img alt="Line" src={icon_edit_line} height={15} />
                ) : current_type === "Polygon" ? (
                  <img alt="Polygon" src={icon_edit_polygon} height={15} />
                ) : (
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                  </svg>
                )}
              </button>
              <button
                id="delete_icon"
                className="outline_grey"
                onClick={on_delete_geometry}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "32px",
                  height: "32px",
                  borderRadius: "8px",
                  backgroundColor: "#fff",
                  color: "#d32f2f",
                  cursor: "pointer",
                  padding: 0,
                }}
                title="Delete Geometry"
              >
                <img alt="Del" src={icon_delete_geometry} width={15} />
              </button>
              {draw_active && !is_mobile && (
                <button
                  className="button_pill hover_primary"
                  onClick={on_stop_draw}
                >
                  {dict["Stop drawing"][language]}
                </button>
              )}
            </>
          )}
        </>
      </div>

      <button
        id="share_ui"
        onClick={toggle_share_modal}
        className="button background_black"
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <svg
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#ffffff"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="18" cy="5" r="3"></circle>
          <circle cx="6" cy="12" r="3"></circle>
          <circle cx="18" cy="19" r="3"></circle>
          <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line>
          <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>
        </svg>
        Share
      </button>
    </section>
  );
};

export default MAP_TOP_BAR;
